import React from 'react';
import classNames from 'classnames';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { SIZES, COLORS } from './constants';

export default function Badge({
  children,
  className = '',
  size = 'md',
  color,
  onRemove,
  removeLabel,
}) {
  return (
    <span
      className={classNames(
        "inline-flex items-center gap-x-1 rounded-md text-xs font-medium ring-1 ring-inset",
        SIZES[size] || SIZES.md,
        color ? COLORS[color] : null,
        className
      )}
    >
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          aria-label={removeLabel || 'Remove'}
          className="-mr-0.5 inline-flex size-4 cursor-pointer items-center justify-center rounded-full text-current opacity-70 transition hover:bg-white/10 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-white/40"
        >
          <XMarkIcon className="size-3" aria-hidden="true" />
        </button>
      )}
    </span>
  );
}
